module.exports = __webpack_public_path__ + "static/media/whatsApp.ba90dc77.svg";